/**
 * The page categories a skeleton can take. A lazy route names the one that matches its page, so the wait shows the
 * shape of what is coming: a data grid, a shift timeline, stat cards, a chart, a settings form, a record's detail, a list.
 */
export type SkeletonVariant = "grid" | "timeline" | "cards" | "chart" | "form" | "detail" | "list";

/** The span a placeholder's count or size is drawn from. `randomCount` includes `max`; `randomBetween` stops short of it. */
export type RandomRange = readonly [min: number, max: number];

/** A number in [min, max). Called once per mount, so the placeholder bars don't reshuffle while the page waits. */
export const randomBetween = ([min, max]: RandomRange): number => min + Math.random() * (max - min);

/** A whole count in [min, max], both ends included. */
export const randomCount = ([min, max]: RandomRange): number => Math.floor(randomBetween([min, max + 1]));
